"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
require("../assets/styles/2fa.css");
var Button_1 = __importDefault(require("../components/Button"));
var FaHeader_1 = __importDefault(require("../utils/FaHeader"));
var react_router_dom_1 = require("react-router-dom");
var axios_1 = require("axios");
var react_hot_toast_1 = __importStar(require("react-hot-toast"));
var AxiosClient_1 = require("../utils/AxiosClient");
var phonHashing_1 = require("../utils/phonHashing");
var js_cookie_1 = __importDefault(require("js-cookie"));
var phoneNumberHandler = function (phoneNumber) {
    if (phoneNumber.startsWith("7")) {
        return "+250".concat(phoneNumber);
    }
    else if (phoneNumber.startsWith("0")) {
        return "+25".concat(phoneNumber);
    }
    else if (phoneNumber.startsWith("+")) {
        return phoneNumber;
    }
    else {
        return null;
    }
};
function VerifyCode() {
    var _a, _b;
    var location = (0, react_router_dom_1.useLocation)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _c = (0, react_1.useState)(false), loading = _c[0], setLoading = _c[1];
    var _d = (0, react_1.useState)(0), response = _d[0], setResponse = _d[1];
    var _e = (0, react_1.useState)(""), error = _e[0], setError = _e[1];
    var _f = (0, react_1.useState)(""), phone_number = _f[0], setPhoneNumber = _f[1];
    var phone = ((_a = location.state) === null || _a === void 0 ? void 0 : _a.phone_number) || null;
    (0, react_1.useEffect)(function () {
        if (phone) {
            setPhoneNumber(phoneNumberHandler(phone));
        }
        else {
            if (localStorage.getItem("phnbr")) {
                setPhoneNumber(phoneNumberHandler(localStorage.getItem("phnbr")));
                if (phoneNumberHandler(localStorage.getItem("phnbr")) != null) {
                    setPhoneNumber(phoneNumberHandler(localStorage.getItem("phnbr")));
                }
                else {
                    react_hot_toast_1.default.error("We can not send a verification code due to invalid phone number update your profile.", { duration: 10000 });
                    navigate("/seller-home");
                }
            }
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (phone_number != "") {
            setLoading(true);
            react_hot_toast_1.default.loading("Sending OTP to your phone");
            AxiosClient_1.AxiosClient.get("/sendcode/".concat(phone_number))
                .then(function (response) {
                react_hot_toast_1.default.remove();
                if (response.data.status == 200) {
                    react_hot_toast_1.default.success("Check Your Messages For OTP.");
                    setLoading(false);
                }
            })
                .catch(function (error) {
                react_hot_toast_1.default.remove();
                if ((0, axios_1.isAxiosError)(error)) {
                    setError("Network error: ".concat(error.message));
                    react_hot_toast_1.default.error(error.message);
                }
                else {
                    setError("Something went wrong ");
                }
                setError("Refresh the page.");
            })
                .finally(function () { return setLoading(false); });
        }
    }, [phone_number]);
    document.title = "Verify OTP";
    var verifyCode = function (phone, otp) {
        react_hot_toast_1.default.loading("Sending your request...");
        setLoading(true);
        AxiosClient_1.AxiosClient.get("/verify/".concat(phone, "/").concat(otp))
            .then(function (response) {
            react_hot_toast_1.default.remove();
            setResponse(response.data.status);
            if (response.data.codeValidity == true) {
                js_cookie_1.default.set("tsver", true, { expires: 30 });
                react_hot_toast_1.default.success("You're verified!", { duration: 4000 });
                window.location.href = "/seller-home";
            }
            else {
                react_hot_toast_1.default.error("Invalid code!");
            }
        })
            .catch(function (error) {
            react_hot_toast_1.default.remove();
            if ((0, axios_1.isAxiosError)(error)) {
                setError("Axios error: ".concat(error.message));
                react_hot_toast_1.default.error(error.message);
            }
            else {
                setError("Something went wrong: ");
            }
        })
            .finally(function () { return setLoading(false); });
    };
    var _g = (0, react_hook_form_1.useForm)(), register = _g.register, handleSubmit = _g.handleSubmit, errors = _g.formState.errors;
    var onSubmit = handleSubmit(function (data) {
        return verifyCode(phone_number, data.sentCode);
    });
    var checkLength = { value: 6, message: "Code Should be 6 digits" };
    return (react_1.default.createElement("div", { className: "setupContainer" },
        react_1.default.createElement(FaHeader_1.default, null),
        react_1.default.createElement("div", { className: "body-text" },
            react_1.default.createElement("p", null, "Enter 6-digit code sent on your phone")),
        react_1.default.createElement("form", { onSubmit: onSubmit },
            phone_number && (0, phonHashing_1.hashPhone)(phone_number),
            react_1.default.createElement("input", __assign({ style: {
                    borderColor: ((_b = errors.sentCode) === null || _b === void 0 ? void 0 : _b.type) == "required" ? "red" : "",
                    textAlign: "center",
                }, type: "number", placeholder: "XXXXXX" }, register("sentCode", {
                required: true,
                maxLength: checkLength,
                minLength: checkLength,
            }), { autoComplete: "off" })),
            response ? "" : "",
            error && react_1.default.createElement("p", { className: "error" }, error),
            (errors === null || errors === void 0 ? void 0 : errors.sentCode) && react_1.default.createElement("p", { className: "error" }, errors.sentCode.message),
            react_1.default.createElement(Button_1.default, { text: "Verify", disabled: loading, type: "submit" })),
        react_1.default.createElement(react_hot_toast_1.Toaster, null)));
}
exports.default = VerifyCode;
